module.exports = __webpack_public_path__ + "assets/img/sdwan-module5-1.90dafb1b.png";